/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { slider } from "./partials/slider.js";
import { accordionImages } from "./partials/accordion-images.js";
import { accordion } from "./partials/accordion.js";
import { map } from "./partials/map.js";
import { popup } from "./partials/popup.js";
import { topAnnouncementBanner } from "./partials/topBanner.js";
import { collapsedText } from "./partials/collapsedText.js";
import { customupload } from "./partials/customupload.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {

    document.querySelector('#skipLink').addEventListener('click', e => {
        document.querySelector('#mainContent').focus();
    });

    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");

    if (formSubmittedElement) {
        setTimeout(() => {
            const targetElement = formSubmittedElement.closest('.form-item');
            window.scrollTo(0, targetElement.offsetTop);
        }, 100);
    }

    //Fire dataLayer event for forms submission
    const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
    if (formSubmitMessage) {
        window.dataLayer.push({
            'event': 'formSubmission',
            'formType': formSubmitMessage.dataset.formName
        });
    }

    intersectionObservation();
    header(body);
    language();
    menu();
    search();
    searchbar(body);
    modal(body, bodyLoadingClass);
    video();
    cookies();
    slider();
    accordionImages();
    accordion();
    map();
    popup();
    topAnnouncementBanner();
    collapsedText();
    customupload();
});
